import type { UploadScope } from '#layers/assets';
import { joinURL } from 'ufo';
import { useRuntimeConfig } from '#app/nuxt';
import { useProjectApiBaseUrl } from '#layers/base';

/**
 * Deletes a file from the assets endpoint
 */
export async function deleteFile(id: string, scope: UploadScope = 'project') {
	const runtimeConfig = useRuntimeConfig();

	const basePath = scope === 'system'
		? joinURL(runtimeConfig.public.api, 'system', 'assets', id)
		: joinURL(useProjectApiBaseUrl(), 'assets', id);

	return $fetch(basePath, {
		method: 'DELETE',
	});
}

export function createFileHooks(scope: UploadScope = 'project') {
	return {
		async delete({ key }: { key: string | number }) {
			await deleteFile(key as string, scope);
		},
		async deleteMany({ keys }: { keys: Array<string | number> }) {
			const results = await Promise.allSettled(keys.map((id) => deleteFile(id as string, scope)));

			const failed = results.filter((result) => result.status === 'rejected');

			if (failed.length > 0) {
				throw new Error(`Failed to delete files ${results.map((_, index) => keys[index]).join(', ')} from storage.`);
			}
		},
	};
}
